import angular from 'angular';
import uiRouter from 'angular-ui-router';

import product from './product.component';
import copy from './copy/copy.module';
import information from './information/information.module';
import loadingAdminForm from './loading-admin-form/loading-admin-form.module';
import loadingAdminList from './loading-admin-list/loading-admin-list.module';
import maintenanceAdminForm from './maintenance-admin-form/maintenance-admin-form.module';
import maintenanceAdminList from './maintenance-admin-list/maintenance-admin-list.module';
import ingredientForm from './ingredient-form/ingredient-form.module';
import ingredientList from './ingredient-list/ingredient-list.module';
import signOff from './sign-off/sign-off.module';
import usageData from './usage-data/usage-data.module';

import './product.scss';

export default
  angular.module('components.app.product', [
    uiRouter,
    copy,
    information,
    loadingAdminForm,
    loadingAdminList,
    maintenanceAdminForm,
    maintenanceAdminList,
    ingredientForm,
    ingredientList,
    signOff,
    usageData
  ])
    .component('product', product)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('productEdit', {
          parent: 'app',
          url: '/products/{id:int}',
          component: 'product',
          resolve: {
            product: ($stateParams, ProductService) =>
              ProductService.getProduct($stateParams.id).then(r => r.data),
            animalTypes: AnimalTypeService =>
              AnimalTypeService.getAnimalTypes().then(r => r.data),
            // TODO: Refactor to OData call
            categories: ProductService =>
              ProductService.getCategories().then(r => r.data),
            frequencies: ProductService =>
              ProductService.getFrequencies().then(r => r.data.map((f) => {
                const obj = {};
                obj.Name = f.Name;
                obj.Value = +f.Value;
                return obj;
              })),
            administrationUnits: ProductService =>
              ProductService.getAdministrationUnitsForSupplements().then(r => r.data),
            weightUnits: ProductService =>
              ProductService.getWeightUnits().then(r => r.data)
          }
        })
        .state('productCreate', {
          parent: 'app',
          url: '/products/create',
          component: 'product',
          resolve: {
            product: currentUser => ({
              ProductId: 0,
              MemberId: currentUser.MemberId
            }),
            animalTypes: AnimalTypeService =>
              AnimalTypeService.getAnimalTypes().then(r => r.data),
            // TODO: Refactor to OData call
            categories: ProductService =>
              ProductService.getCategories().then(r => r.data),
            frequencies: ProductService =>
              ProductService.getFrequencies().then(r => r.data.map((f) => {
                const obj = {};
                obj.Name = f.Name;
                obj.Value = +f.Value;
                return obj;
              })),
            administrationUnits: ProductService =>
              ProductService.getAdministrationUnitsForSupplements().then(r => r.data),
            weightUnits: ProductService =>
              ProductService.getWeightUnits().then(r => r.data)
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/product/product.module.js